import React from 'react';
import Layout from '../components/Layout';
import PrivacySettings from '../components/PrivacySettings';
import { useAuth } from '../context/AuthContext';
import './Profile.css';

const Profile = () => {
  const { user } = useAuth();

  return (
    <Layout>
      <div className="profile-page">
        <div className="profile-header">
          <h1>Privacy & Public Profile Settings</h1>
          <p>Manage your privacy preferences and public profile visibility</p>
        </div>

        {/* Public Profile & Privacy Settings */}
        <div className="profile-card card">
          <PrivacySettings userId={user?._id} />
        </div>
      </div>
    </Layout>
  );
};

export default Profile;
